namespace RioErp.Web.Enums {
    export enum FranchiseePaymentType {
        FromWallet = 1,
        Prepaid = 2,
        Postpaid = 4
    }
    Serenity.Decorators.registerEnumType(FranchiseePaymentType, 'RioErp.Web.Enums.FranchiseePaymentType');
}
